// extracted by mini-css-extract-plugin
module.exports = {"save-complete":"saved-setting-toast__save-complete___2b9Yx","spinner":"saved-setting-toast__spinner___1Xe78"};